import { useSelector, shallowEqual } from 'react-redux';
import { getRefillLoading } from '../selectors';

export const useRefillLoading = () => ({
  loading: useSelector(getRefillLoading, shallowEqual),
});
